module.exports = __webpack_public_path__ + "img/back-arrow.01129042.svg";